<div id="irt-planner-root-layout" class="irt-full-height">
  <app-toolbar          class="irt-toolbar" [currentItem]="navbarItem"></app-toolbar>
  <app-navbar           class="irt-navbar"  [currentItem]="navbarItem"></app-navbar>
  <app-planner-section  class="irt-section"></app-planner-section>
</div>
